import { gql } from 'apollo-angular';
import { Tenant } from '../../entities/tenant/tenant';


export const UPDATE_TENANT_MUTATION = gql`
mutation updateTenant($input: TenantInput) {
  updateTenant(tenantInput: $input) {
    id
  }
}
`;


export const CREATE_TENANT_MUTATION = gql`
mutation createTenant($input: TenantInput) {
  createTenant(tenantInput: $input) {
    id
  }
}
`;

export const SWITCH_TENANT_MUTATION = gql`
mutation switchTenant($tenant: String) {
  switchTenant(tenant: $tenant)
}
`;


export const UPDATE_INVOICEMAIL_MUTATION = gql`
mutation updateInvoiceMail($id: UUID, $invoiceMail: String ) {
  updateInvoiceMail(id: $id, invoiceMail: $invoiceMail) {
    id
  }
}
`;

export const UPDATE_INVOICE_ADDRESS_MUTATION = gql`
mutation updateInvoiceAddress($input: TenantInvoiceAddressInput ) {
  updateInvoiceAddress(input: $input) {
    id
  }
}
`;

export const DELETE_INVOICE_ADDRESS_MUTATION = gql`
mutation deleteInvoiceAddress($id: UUID ) {
  deleteInvoiceAddress(id: $id) {
    id
  }
}
`;

export const DELETE_LICENCE_REQUESTS_MUTATION = gql`
mutation cancelAllLicenceRequestsForTenant($tenantId: UUID ) {
  cancelAllLicenceRequestsForTenant(tenantId: $tenantId)
}
`;

export const DELETE_INVOICE_EMAIL_MUTATION = gql`
mutation deleteInvoiceMail($id: UUID ) {
  deleteInvoiceMail(id: $id) {
    id
  }
}
`;

export function getTenantQuery(fragment: string, fragmentName: string) {
    return gql`
      ${fragment}
      query getTenantQuery(
        $id: String
      )
      {
        tenant: getTenantByTenantId(
          tenantId: $id
        )
        {
          ...${fragmentName}
        },
      }
      `;
  }

/**
 * fragment loads all fields of tenant excluding administrative or payment relevant fields
 */
export const DEFAULT_TENANT_FRAGMENT_NAME = 'DefaultTenantFields';
export const DEFAULT_TENANT_FRAGMENT = `
  fragment ${DEFAULT_TENANT_FRAGMENT_NAME} on Tenant {
    id
    name
    additionalName
    email
    addressLine0
    addressLine1
    postalCode
    city
    country
    phone
    vatNumber
    paymentProviderEnabled
    invoiceEmail
  }
`;

/**
 * fragment loads all fields of tenant including administrative relevant fields but excluding payment information
 * TODO
 */
export const ADMIN_TENANT_FRAGMENT_NAME = 'AdminTenantFields';
const ADMIN_TENANT_FRAGMENT = `
  fragment ${ADMIN_TENANT_FRAGMENT_NAME} on Tenant {
    id
    name
    additionalName
    email
    addressLine0
    addressLine1
    postalCode
    city
    country
    phone
    vatNumber
    paymentProviderEnabled
    invoiceEmail
    paymentProviderId
    description
  }
`;

export interface TenantQueryResponse {
  tenant: Tenant;
  loading: boolean;
}